import { useTranslation } from 'next-i18next/pages';

/* eslint-disable @next/next/no-img-element */
import { Button } from 'antd';

import { REGISTER_STORAGE_URL } from '@/constants/routes';
import { TranslationNamespace } from '@/i18n';
import { ymOnRegistrationWarehouseStoragePage } from '@/metrics';

import { FishIcons } from './icons';

export default function StorageHeading() {
	const t = useTranslation(TranslationNamespace.Marketing).t;
	return (
		<section className="storage-section1">
			<FishIcons />
			<div className="containerWarehouse">
				<h1 className="storage-section1-title">
					{t('storage.storage-heading.automate-communication-with-customers')}
				</h1>
				<p className="storage-section1-subtitle">
					{t(
						'storage.storage-heading.increase-warehouse-profitability-by-efficiently-distributing-storage-occ',
					)}
					.
				</p>
				<Button
					href={REGISTER_STORAGE_URL}
					size="large"
					data-testid="storage-registration-btn"
					onClick={ymOnRegistrationWarehouseStoragePage}
				>
					{t('storage.storage-heading.register-a-warehouse')}
				</Button>
			</div>
			<img className="storage-section1-decor1" src="/img/storage-section1-decor1.webp" alt="" />
			<img className="storage-section1-decor2" src="/img/storage-section1-decor2.webp" alt="" />
		</section>
	);
}
